import { Device } from "../utils/response";

export const enum DeviceReducerActionType {
  UPDATE_DEVICE_LIST = 'UPDATE_DEVICE_LIST',
  UPDATE_ACTIVE_DEVICE = 'UPDATE_ACTIVE_DEVICE',
}

export interface DeviceReducerAction {
  type: DeviceReducerActionType;
  payload?: Device[] | string | any;
}

interface DeviceInfo extends Device{
  [key: string]: any;
}

export const deviceReducer = (state: DeviceInfo[], action: DeviceReducerAction) => {
  const { type, payload } = action;
  switch(type) {
  case DeviceReducerActionType.UPDATE_DEVICE_LIST:
    return payload.sort((a: DeviceInfo, b: DeviceInfo) => { return  b.remainDays - a.remainDays;})
                  .map((dev: DeviceInfo) => {
                    if(payload.indexOf(dev) === 0) {
                      return { ...dev, isActive: true };
                    } else { 
                      return { ...dev, isActive: false };
                    }
                  });
  case DeviceReducerActionType.UPDATE_ACTIVE_DEVICE:
    return state.map(<T extends Device>(dev: T) => {
      if(dev.guid === payload) {
        return { ...dev, isActive: true };
      } else { 
        return { ...dev, isActive: false };
      }
    });
  default:
    return state;
  }
};
